import { z } from 'zod';
import { ssnCountries } from '../enums.js';

/**
 * Champs d'identité que Doctena peut avoir fournis. L'ordre est celui du récapitulatif affiché
 * sur le formulaire. Le matricule n'y figure pas : Doctena ne le transmet pas.
 */
export const doctenaOriginFields = [
  'firstName',
  'lastName',
  'email',
  'phone',
  'birthDate',
] as const;
export type DoctenaOriginField = (typeof doctenaOriginFields)[number];

/**
 * Identité proposée pour préremplir « Nouveau patient » depuis un rendez-vous sans dossier.
 *
 * Écrite à la main : ce n'est pas une ligne de `appointments`, et un schéma dérivé de la table
 * laisserait passer des colonnes qui n'ont rien à faire dans un formulaire.
 *
 * `ssnCountry` n'est renseigné que lorsque le pays du matricule est vraiment connu. Absent, le
 * formulaire garde le sélecteur tel qu'il est — on ne le déduit ni du téléphone, ni du cabinet.
 *
 * `fromDoctena` ne liste que les champs déjà remplis par Doctena (instantané ou lecture du
 * patient par identifiant). Un champ vide, que le praticien saisira, n'y est pas.
 */
export const appointmentPatientProposalSchema = z
  .object({
    firstName: z.string().max(100),
    lastName: z.string().max(100),
    email: z.string().max(254).nullable(),
    phone: z.string().max(40).nullable(),
    birthDate: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .nullable(),
    ssnCountry: z.enum(ssnCountries).nullable(),
    fromDoctena: z.array(z.enum(doctenaOriginFields)),
  })
  .strict();

export type AppointmentPatientProposalDto = z.infer<typeof appointmentPatientProposalSchema>;
